import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgStyle} from '@angular/common';
import {MenuButtonsComponent} from '../menu-buttons/menu-buttons.component';
import {MenuButtonsHeaderComponent} from '../menu-buttons-header/menu-buttons-header.component';

@Component({
  selector: 'app-menu-buttons-page',
  templateUrl: './menu-buttons-page.component.html',
  styleUrls: ['./menu-buttons-page.component.scss'],
  imports: [NgStyle, MenuButtonsComponent, MenuButtonsHeaderComponent],
})
export class MenuButtonsPageComponent {

  @Input() label: string = '';
  @Input() topActions: TopAction[] = [];
  @Input() backgroundImage: string = '';
  @Output() actionClick = new EventEmitter<any>();

  getBackgroundStyle(): string {
    return `linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.55),
      rgba(0, 0, 0, 0.55)
    ), url('${this.backgroundImage}') center/cover no-repeat #000`;
  }


  constructor() {
  }

  onActionClick(action: any) {
    this.actionClick.emit(action);
  }

}
